var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "healthyCommunity pb-5 ctm-container" },
    [
      _c("h1", { staticClass: "healthy-community-title my-3" }, [
        _vm._v(_vm._s(_vm.$t("healthyCommunityTitle")))
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "d-flex justify-content-center" },
        _vm._l(_vm.cards, function(item) {
          return _c("healthy-community-vertical-card", {
            key: item.title,
            attrs: {
              path: item.path,
              soonLabel: item.soonLabel,
              sectionId: item.sectionId,
              img: item.img,
              title: item.title,
              description: item.description,
              onlySubscribers: item.onlySubscribers
            }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18980053", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18980053","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/healthy-community/HealthyCommunity.vue
// module id = 3646
// module chunks = 7